import styled from 'styled-components';

export const Address = styled.div`
    margin-top: 12px;
`;

export const MapContainer = styled.div`
    border: 1px solid ${p => p.theme.c.dark};
    height: 200px;
    pointer-events: none;
`;